import { styled } from '@mui/system'
import { DataGrid } from '@mui/x-data-grid'

export const UsersTablePaper = styled('div')(() => ({
  height: 350,
  width: 792,
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
  },
}))

export const UsersTableActionButton = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'left',
}))

export const UsersTableDataGrid = styled(DataGrid)(({ theme }) => ({
  overflowX: 'auto',

  '& .MuiDataGrid-columnHeader, .MuiDataGrid-filler, .MuiDataGrid-scrollbarFiller--header': {
    backgroundColor: theme.palette.primary.light,
  },
  '& .MuiDataGrid-columnHeaderTitle, .MuiDataGrid-scrollbarFiller': {
    color: 'white',
  },
}))
